import './ErrorNotification.less';

const ErrorNotification = ({ message }: { message: string }) => {
    return (
        <div className="error-notification">
            {message}
        </div>
    )
}

export default ErrorNotification;